import React, { useState } from "react";
import * as Components from "../../../components/all";
import { useParams } from "react-router-dom";

import { MdOutlineLocalOffer, MdOutlinePriceChange } from "react-icons/md";
import { BsCalendar3, BsTextLeft } from "react-icons/bs";
import { TbPercentage } from "react-icons/tb";
import { RiIncreaseDecreaseFill } from "react-icons/ri";
import { BiTrendingUp } from "react-icons/bi";

export default function RatesPS() {
	const params = useParams();
	const [loading, setLoading] = useState(false);
	// Map
	const [showMap, setShowMap] = useState(false);
	// Allow Edit
	const [allowEdit, setAllowEdit] = useState(false);

	// Styles
	var mainContainerStyles = `flex flex-col justify-center 
    flex-wrap sm:mx-20 md:mx-24`;
	var containerStyles = `h-fit w-full flex items-cente p-2 text-darker overflow-x-auto border rounded-md shadow-sm m-1`;
	var iconStyles = `h-6 aspect-square flex items-center justify-center text-dark borde mr-3`;
	var inputStyles = `flex-1 bg-transparent text-sm text-darker focus:outline-none`;

	// New Parking Space
	const [newRate, setNewRate] = useState({
		psName: "Comsats University Islamabad",
		normal: 200,
		peak: 20,
		fill: 80,
	});

	// Handle Update
	const handleUpdate = () => {
		console.log(newRate);
		for (var key in newRate) {
			if (newRate.hasOwnProperty(key) && newRate[key] === null) {
				console.log("Found null value for property:", key);
			}
		}
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="RatePS
            overflow-x-hidden overflow-y-auto 
            h-full
            w-full
            sm:p-3 md:p-5
            flex flex-col
            "
		>
			{/* TOP CARDS ROW */}
			<div className="TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-1">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="relative
					min-h-[450px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* Heading */}
					<div
						className="
							w-full
							p-2 pt-0 
							flex 
							items-center 
							flex-wrap
							"
					>
						<Components.BackButton />
						<h1 className="ml-2 text-darker">{newRate.psName}</h1>

						{allowEdit === false && (
							<button
								className="bg-main text-white ml-auto px-4 py-1 rounded-full hover:opacity-70 text-sm max-sm:mt-2"
								onClick={() => setAllowEdit(true)}
							>
								Edit
							</button>
						)}
						{allowEdit === true && (
							<div className="max-sm:w-full max-sm:mt-2 flex items-end flex-1">
								<button
									className="bg-red-400 text-white ml-auto px-4 py-1 rounded-full hover:opacity-70 text-sm"
									onClick={() => setAllowEdit(false)}
								>
									Cancel
								</button>
								<button
									className="bg-green-400 text-white ml-2 px-4 py-1 rounded-full hover:opacity-70 text-sm"
									onClick={() => handleUpdate()}
								>
									Update
								</button>
							</div>
						)}
					</div>

					{/* Package Info */}
					<div className={mainContainerStyles}>
						{/* divider */}
						<div className="w-full my-5">
							<h1 className="w-fit px-4 border-b mx-auto text-darker uppercase">
								Rate Information
							</h1>
						</div>

						{/* normal */}
						<div className={containerStyles}>
							<div className={iconStyles}>
                            <MdOutlinePriceChange />
							</div>
							<input
								readOnly={!allowEdit}
								type="number"
								className={inputStyles}
								placeholder="Normal parking rate"
								value={newRate.normal}
								onChange={(e) =>
									setNewRate((prev) => ({ ...prev, normal: e.target.value }))
								}
							/>
						</div>

						{/* peak */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<BiTrendingUp />
							</div>
							<input
								readOnly={!allowEdit}
								type="number"
								className={inputStyles}
								placeholder="Peak rate percentage"
								value={newRate.peak}
								onChange={(e) =>
									setNewRate((prev) => ({ ...prev, peak: e.target.value }))
								}
							/>
						</div>

						{/* fill */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<TbPercentage />
							</div>
							<input
								readOnly={!allowEdit}
								type="number"
								className={inputStyles}
								placeholder="Parking percentage for peak factor"
								value={newRate.fill}
								onChange={(e) =>
									setNewRate((prev) => ({ ...prev, fill: e.target.value }))
								}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
